import { FormSection } from '../../elements/forms/formSection/FormSection';
import { RequestMessage } from './RequestMessage';

interface IRequestMessageContainerProps {
    requestMessages: IRequestMessage[];
}

export function RequestMessageContainer(props: IRequestMessageContainerProps) {
    return (
        <FormSection type="postit">
            {props.requestMessages.map((requestMessage) => (
                <RequestMessage
                    key={requestMessage.id}
                    requestMessage={requestMessage}
                />
            ))}
        </FormSection>
    );
}

export interface IRequestMessage {
    created_at: string;
    employment: {
        organizationId: string;
        practitioner: {
            nameFamily?: string;
            nameGiven?: string;
            nameInfix?: string;
        };
        practitionerId: string;
    };
    employmentId: string;
    id: string;
    message: string;
}
